
import { RadioElement } from '05-ui-kit';
type typeValue = number | string;
const __sfc_main = {};
__sfc_main.props = {
  modelValue: {
    key: "modelValue",
    required: false,
    type: null
  },
  list: {
    key: "list",
    required: true,
    type: Array
  },
  name: {
    key: "name",
    required: false,
    type: String,
    default: 'history-item'
  },
  borderRadius: {
    key: "borderRadius",
    required: false,
    type: String,
    default: '5px'
  },
  emptyText: {
    key: "emptyText",
    required: false,
    type: String,
    default: 'Нет доступных значений'
  },
  isChecked: {
    key: "isChecked",
    required: false,
    type: Function,
    default: (val, prop) => val === prop
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  return {
    emit
  };
};
__sfc_main.components = Object.assign({
  RadioElement
}, __sfc_main.components);
export default __sfc_main;
